












































import { ref, defineComponent, toRefs, reactive } from '@vue/composition-api'

import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'ChangePageMenu',
  components: {
    CloseButton,
  },
  props: {
    numberOfPages: Number,
  },
  setup(props, { root, emit }) {
    const ChangePageForm = ref(null)
    const data = reactive({
      valid: true,
      page: null,
      open: false,
      pageRules: [
        (v: string) =>
          !!v || root.$t('mediaItemOccurence.changePage.pageRequired'),
        (v: string) => {
          const number = parseInt(v, 10)
          return (
            (!isNaN(number) && number > 0 && number <= props.numberOfPages) ||
            root.$t('mediaItemOccurence.changePage.invalidRange', {
              numberOfPages: props.numberOfPages,
            })
          )
        },
      ],
    })

    const submit = async () => {
      const form = ChangePageForm.value
      form.validate()
      if (!data.valid) {
        return
      }
      emit('change-page', parseInt(data.page, 10))
      data.open = false
      data.page = null
    }

    return {
      ...toRefs(data),
      ChangePageForm,
      submit,
    }
  },
})
